import React, { useContext } from "react";
import { LanguageContext } from "./contexts/LanguageContext";
import { GenericHint } from "./components/GenericHint";

const imgRules = new URL("../img/ID.manual-2.gif", import.meta.url);

export const Hints2 = () => {
    const language = useContext(LanguageContext);

    return (
        <GenericHint
            imgSrc={imgRules.toString()}
            nextRoute="/hints3"
            doText={language.hints2_do_text}
            dontText={language.hints2_dont_text}
        />
    );
}